(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-fw-l1-vids]:not([data-fw-vids-bound])').forEach(function (root) {
      root.setAttribute('data-fw-vids-bound', '');
      var track = root.querySelector('[data-fw-vid-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fw-vid-card]'));
      if (!track || !cards.length) return;
      var videos = cards.map(function (card) { return card.querySelector('video'); });
      var prev = root.querySelector('[data-fw-vid-prev]');
      var next = root.querySelector('[data-fw-vid-next]');
      var count = root.querySelector('[data-fw-vid-count]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fw-vid-dot]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sectionSeen = false;
      var inView = {};
      var near = {};
      var active = 0;
      var frame = 0;
      function silence(video) {
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
      }
      function load(video, full) {
        if (!video) return;
        if (full && video.preload !== 'auto') video.preload = 'auto';
        if (video.getAttribute('data-loaded') === '1') return;
        var source = video.querySelector('source[data-src]');
        if (!source) return;
        video.preload = full ? 'auto' : 'metadata';
        source.src = source.getAttribute('data-src');
        video.setAttribute('data-loaded', '1');
        video.load();
      }
      function sync() {
        videos.forEach(function (video, index) {
          if (!video) return;
          if (sectionSeen && near[index]) load(video, false);
          if (!reduce && sectionSeen && inView[index] && !document.hidden) {
            silence(video);
            load(video, true);
            if (video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }
      videos.forEach(function (video) {
        if (!video) return;
        silence(video);
        video.addEventListener('volumechange', function () { if (!video.muted || video.volume > 0) silence(video); });
      });
      if ('IntersectionObserver' in window) {
        var cardObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { inView[cards.indexOf(entry.target)] = entry.intersectionRatio >= 0.5; });
          sync();
        }, { root: track, threshold: [0, 0.5, 1] });
        var nearObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { near[cards.indexOf(entry.target)] = entry.isIntersecting; });
          sync();
        }, { root: track, rootMargin: '0px 60% 0px 60%' });
        var sectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sectionSeen = entry.isIntersecting && entry.intersectionRatio > 0.15;
          });
          sync();
        }, { threshold: [0, 0.15, 0.5] });
        cards.forEach(function (card) { cardObserver.observe(card); nearObserver.observe(card); });
        sectionObserver.observe(root);
      } else {
        videos.forEach(function (video) { load(video, false); });
      }
      function step() {
        return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].getBoundingClientRect().width;
      }
      function update() {
        frame = 0;
        active = cards.reduce(function (best, card, index) {
          return Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - track.scrollLeft) ? index : best;
        }, 0);
        if (count) count.textContent = (active + 1) + ' / ' + cards.length;
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === active);
          if (index === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }
      function go(index) {
        var target = Math.max(0, Math.min(cards.length - 1, index));
        track.scrollTo({ left: target * step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(active - 1); });
      if (next) next.addEventListener('click', function () { go(active + 1); });
      dots.forEach(function (dot, index) { dot.addEventListener('click', function () { go(index); }); });
      track.addEventListener('scroll', function () {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { if (frame) cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }).observe(track);
      document.addEventListener('visibilitychange', sync);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
